import React, { useState } from 'react';
import './ModalSchedule.css';
import OrgSelect from '../../components/OrgSelect/OrgSelect';

const ModalSchedule = ({ type, data, onClose, onConfirm, toggleSelect }) => {
  const [showOrgPopup, setShowOrgPopup] = useState(false);
  const [participants, setParticipants] = useState([]);

  return (
    <div className="schedule_backdrop">
      
      {/* 🔎 검색 결과 모달 */}
      {type === 'searchResult' && (
        <div className="schedule_modal_01_searchResult">
          <div className="schedule_modal_01_header">검색결과</div>
          <div className="schedule_modal_01_body">
            <ul className="schedule_modal_01_list">
              {data.users?.map((user, idx) => (
                <li key={`user-${idx}`}>
                  <input
                    type="checkbox"
                    checked={user.checked || false}
                    onChange={() => toggleSelect(user, 'user')}
                  />
                  {user.name} / {user.position} ({user.dept_name})
                </li>
              ))}
              {data.depts?.map((dept, idx) => (
                <li key={`dept-${idx}`}>
                  <input
                    type="checkbox"
                    checked={dept.checked || false}
                    onChange={() => toggleSelect(dept, 'dept')}
                  />
                  {dept.full_dept_name}
                </li>
              ))}
            </ul>
          </div>
          <div className="schedule_modal_01_buttons">
            <button onClick={onConfirm}>확인</button>
            <button onClick={onClose}>취소</button>
          </div>
        </div>
      )}

      {/* 🏢 조직도 모달 */}
      {type === 'orgSelect' && showOrgPopup && (
        <OrgSelect
          onConfirm={(targets) => {
            const newParticipants = targets.map(t =>
              t.target_type === 'user'
                ? {
                    target_type: 'user',
                    target_id: t.target_id,
                    name: t.target_name,
                    position: t.position || '',
                    dept_name: t.dept_name || '',
                    target_name: `${t.target_name} / ${t.position || ''} (${t.dept_name || ''})`,
                    checked: false,
                  }
                : {
                    target_type: 'dept',
                    target_id: t.target_id,
                    target_name: t.target_name,
                    checked: false,
                  }
            );

            setParticipants(prev => {
              const ids = prev.map(p => p.target_id);
              const merged = [...prev];
              newParticipants.forEach(np => {
                if (!ids.includes(np.target_id)) merged.push(np);
              });
              return merged;
            });

            setShowOrgPopup(false);
          }}
          onCancel={() => setShowOrgPopup(false)}
          selectionMode="multiple"
          targetType="all"
          initialSelected={participants}
        />
      )}
    </div>
  );
};

export default ModalSchedule;
